import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import useTranslation from '@/utils/hooks/translation/useTranslation';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';

import PropTypes from 'prop-types';

import { postsSortTypes } from '@/lib/posts/postSortTypes';
// Lib
import { INSTAGRAM, PINTEREST } from '@/lib/socialProfile';

import Checkbox from '@/components/base/Checkbox';
// Components
import Label from '@/components/base/Label';
import FilterSectionTitle from '@/components/pages/myprofile/filters/FilterSectionTitle';

const FilterPostType = ({ resetFilters, stopResetFilters, setRequestParams }) => {
    const router = useRouter();
    const { filterPostType } = router.query;
    const { deleteQuery } = useRouterQuery();

    const { t } = useTranslation('commons');
    const { activeSocialProfile } = useActiveSocialProfile();
    const typePostList = postsSortTypes(t)[activeSocialProfile?.social_network_type ?? INSTAGRAM];
    const [activeType, setActiveType] = useState(
        filterPostType ? JSON.parse(filterPostType) : [typePostList[0].value]
    );

    useEffect(() => {
        if (filterPostType) {
            const newUrl = deleteQuery(['filterPostType']);
            router.replace(newUrl);
        }
    }, [filterPostType]);

    useEffect(() => {
        setRequestParams((prevState) => {
            if (activeType?.filter((item) => item === 'all').length === 0) {
                return {
                    ...prevState,
                    filter_post_type: activeType
                };
            }

            if (prevState) {
                delete prevState.filter_post_type;
            }

            return { ...prevState };
        });
    }, [activeType, setRequestParams]);

    useEffect(() => {
        if (resetFilters) {
            setActiveType([typePostList[0].value]);
            stopResetFilters();
        }
    }, [resetFilters]);

    const checkboxClick = (e) => {
        const valueCheckbox = e.target.value;
        if (valueCheckbox === 'all') {
            setActiveType(['all']);
        } else {
            if (activeType.filter((item) => item === valueCheckbox).length) {
                const newList = activeType.filter((item) => item !== valueCheckbox);
                if (newList.length) {
                    setActiveType(newList);
                } else {
                    setActiveType(['all']);
                }
            } else {
                setActiveType((prevState) => [
                    ...prevState.filter((item) => item !== 'all'),
                    valueCheckbox
                ]);
            }
        }
    };

    return (
        <div>
            <FilterSectionTitle icon="content">
                {t(
                    `myprofile:${
                        activeSocialProfile?.social_network_type === PINTEREST ? 'pin' : 'post'
                    }_type`
                )}
            </FilterSectionTitle>
            <ul className="space-y-2.5">
                {typePostList.map((typePost) => {
                    const isDisabled =
                        activeType.filter(
                            (item) => item === typePost.value && typePost.value === 'all'
                        ).length === 1;
                    return (
                        <li key={typePost.value}>
                            <Label
                                fontType={isDisabled ? 'checkboxListDisabled' : 'checkboxList'}
                                className="relative cursor-pointer pl-7">
                                <Checkbox
                                    id={`type-post-${typePost.value}`}
                                    onChange={checkboxClick}
                                    checked={
                                        activeType.filter((item) => item === typePost.value).length
                                    }
                                    value={typePost.value}
                                    className="absolute left-0 top-0"
                                    disabled={isDisabled}
                                />
                                <span className="align-middle">{typePost.label}</span>
                            </Label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

FilterPostType.propTypes = {
    resetFilters: PropTypes.bool,
    stopResetFilters: PropTypes.func,
    setRequestParams: PropTypes.func.isRequired
};

export default FilterPostType;
